import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { toastVariants, transition } from '../lib/motion.js';
import { useToast } from '../store/useToast.js';

const TONE_STYLES = {
  success: 'border-emerald-500/30 bg-emerald-500/15 text-emerald-100',
  error: 'border-red-500/30 bg-red-500/15 text-red-100',
  info: 'border-sky-500/30 bg-sky-500/15 text-sky-100',
  default: 'border-border bg-bg-card text-white',
};

const TONE_ICONS = {
  success: '✓',
  error: '✕',
  info: 'i',
  default: '•',
};

export default function Toaster() {
  const toasts = useToast((s) => s.toasts);
  const dismiss = useToast((s) => s.dismiss);
  const reduceMotion = useReducedMotion();

  return (
    <div
      className="pointer-events-none fixed inset-x-0 top-[max(env(safe-area-inset-top),12px)] z-[60] flex justify-center px-4"
      role="status"
      aria-live="polite"
    >
      <div className="container-mobile flex flex-col items-stretch gap-2">
        <AnimatePresence initial={false}>
          {toasts.map((t) => (
            <motion.button
              type="button"
              key={t.id}
              onClick={() => dismiss(t.id)}
              className={`pointer-events-auto flex w-full items-start gap-2 rounded-xl border px-3 py-2.5 text-left text-sm shadow-lg ${
                TONE_STYLES[t.tone] ?? TONE_STYLES.default
              }`}
              variants={toastVariants}
              initial={reduceMotion ? false : 'initial'}
              animate="animate"
              exit={reduceMotion ? undefined : 'exit'}
              transition={transition(reduceMotion, 'medium')}
            >
              <span className="mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/15 text-[11px] font-bold">
                {TONE_ICONS[t.tone] ?? TONE_ICONS.default}
              </span>
              <span className="min-w-0 flex-1 leading-snug">{t.message}</span>
            </motion.button>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}
